import { cn } from "@/lib/utils";
import { useLanguage, type Lang } from "@/lib/i18n";

const OPTIONS: { code: Lang; label: string; flag: string }[] = [
  { code: "es", label: "ES", flag: "🇪🇸" },
  { code: "en", label: "EN", flag: "🇬🇧" },
  { code: "fr", label: "FR", flag: "🇫🇷" },
];

export function LanguageToggle() {
  const { lang, setLang, t } = useLanguage();
  return (
    <div
      role="group"
      aria-label={t.toggleAria}
      className="inline-flex items-center rounded-full border bg-card/90 backdrop-blur p-1 text-sm font-medium shadow-sm"
    >
      {OPTIONS.map((opt) => (
        <button
          key={opt.code}
          type="button"
          onClick={() => setLang(opt.code)}
          aria-pressed={lang === opt.code}
          aria-label={opt.label}
          className={cn(
            "inline-flex h-9 w-9 items-center justify-center rounded-full text-xl leading-none transition-colors",
            lang === opt.code
              ? "bg-foreground"
              : "opacity-60 hover:opacity-100"
          )}
        >
          <span aria-hidden="true">{opt.flag}</span>
        </button>
      ))}
    </div>
  );
}
